import { RootState } from 'app/rootReducer'
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Redirect } from 'react-router-dom'
import LoginForm from '../../../organisms/LoginForm'
import './styles.scss'

const LoginPage = (): JSX.Element => {
  const authentication = useSelector((state: RootState) => state.authentication)

  useEffect(() => {
    console.log('auth login', authentication)
  }, [authentication])

  if (
    authentication.accessToken &&
    authentication.account &&
    authentication.account.id
  ) {
    if (authentication.account?.caseCount === 1) {
      return (
        <Redirect
          to={{
            pathname: '/dashboard/case'
          }}
        />
      )
    } else {
      return (
        <Redirect
          to={{
            pathname: '/client'
          }}
        />
      )
    }
  }
  return (
    <>
      <div className='ui-login-page'>
        <h1 data-test-id='login-page-title'>Welcome Back!</h1>
        <span data-testid='login-page-message'>
          Log in to check on your case.
        </span>
        <LoginForm />
      </div>
    </>
  )
}

export default LoginPage
